import React from 'react';
import { ModalBase } from '@panel/commons';
import styled, { css } from 'styled-components';
import { select } from '@panel/commons/core/themev2';
import { getColor } from '@panel/commons/core/themev3';

function SaveChangeForm({
  onClose,
  openModal,
  handleRedirect,
  handleKeepEditing,
  title,
  description,
  exitButtonText,
  keepButtonText,
  bottomModal = false
}) {
  return (
    <ModalBase openModal={openModal} onClose={onClose} width='400px' bottomModal={bottomModal}>
      <Container data-publi='formGuardModal-container'>
        <Title data-publi='formGuardModal-container-title'>{title}</Title>
        <Description data-publi='formGuardModal-container-description'>{description}</Description>
        <ButtonsContainer data-publi='formGuardModal-buttons' bottomModal={bottomModal}>
          <OnlyRedirect
            type='button'
            onClick={handleRedirect}
            data-publi='formGuardModal-CTA1'
            bottomModal={bottomModal}
          >
            {exitButtonText}
          </OnlyRedirect>
          <SaveAndRedirect
            type='button'
            id='saveAndRedirect'
            onClick={handleKeepEditing}
            data-publi='formGuardModal-CTA2'
            bottomModal={bottomModal}
          >
            {keepButtonText}
          </SaveAndRedirect>
        </ButtonsContainer>
      </Container>
    </ModalBase>
  );
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 24px;
  padding-top: 16px;
`;

const ButtonsContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  ${({ bottomModal }) =>
    bottomModal &&
    css`
      flex-direction: column-reverse;
      gap: 16px;
    `}
`;

const Title = styled.h4`
  font-family: Hind;
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 130%;
  max-width: 90%;
  white-space: break-spaces;
  text-align: center;
  margin-top: 10px;
  color: ${select('black')};
`;

const Description = styled.p`
  text-align: center;
  white-space: break-spaces;
  font-family: Hind;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  margin: 20px 0;
  line-height: normal;
`;

const buttonStyles = css`
  width: 48%;
  height: 40px;
  border-radius: 12px;
  font-size: 16px;
  font-weight: 600;
  line-height: 1.3;
  cursor: pointer;
`;

const SaveAndRedirect = styled.button`
  color: ${select('white')};
  background-color: ${getColor('primary')};
  ${buttonStyles}
  ${({ bottomModal }) =>
    bottomModal &&
    css`
      width: 100%;
    `}
`;

const OnlyRedirect = styled.button`
  color: ${select('black')};
  background-color: ${select('white')};
  border: 1px solid ${getColor('primary')};
  ${buttonStyles}
  ${({ bottomModal }) =>
    bottomModal &&
    css`
      width: 100%;
    `}
`;

export { SaveChangeForm };
